
import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";

const AdvantagesPreview = () => {
  return (
    <section className="py-16 bg-[#2A2A2A]">
      <div className="container mx-auto px-4">
        <h2 className="text-3xl font-bold mb-8 text-center text-accent hover:text-accent-hover transition-colors">
          Advantages To Repairing Your Appliances
        </h2>
        
        <div className="grid grid-cols-1 md:grid-cols-2 gap-8 mb-8">
          <div className="relative h-[250px]">
            <img
              src="/lovable-uploads/0d893a2f-ae6b-434f-b73c-70eff4681fb8.png"
              alt="Professional appliance repair"
              className="w-full h-full object-cover rounded-lg"
            />
          </div>
          
          <div className="space-y-4">
            <div className="p-4 bg-[#333333] rounded-lg">
              <h3 className="text-lg font-semibold text-white mb-2">
                Fast & Convenient Solution
              </h3>
              <p className="text-gray-300">
                Most repairs take between 2-24 hours, avoiding the wait for new appliance delivery.
              </p>
            </div>
            
            <div className="p-4 bg-[#333333] rounded-lg">
              <h3 className="text-lg font-semibold text-white mb-2">
                Cost-Effective Choice
              </h3>
              <p className="text-gray-300">
                Costs fractions of what a new appliance would.
              </p>
            </div>
          </div>
        </div>
        
        <div className="text-center">
          <Link
            to="/advantages"
            className="inline-flex items-center gap-2 text-primary hover:text-primary-hover transition-colors"
          >
            Learn more about the benefits of appliance repair
            <ArrowRight className="w-4 h-4" />
          </Link>
        </div>
      </div>
    </section>
  );
};

export default AdvantagesPreview;
